import {
  FETCH_PAGE,
  SUBMIT_PAGE,
  DELETE_PAGE,
  REFRESH_PAGE_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refsreh: false,
};

export default function page(state = initialState, action) {
  switch (action.type) {
    case FETCH_PAGE:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_PAGE:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_PAGE:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_PAGE_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
